export const CHARTFIELD = "AIAMN/OHXENIA/NEWSLETTER/PLS";
//export const API = "https://localhost:8080/api/";
export const API = "https://p76orop34e.execute-api.us-east-1.amazonaws.com/latest/api/";

export const BILLINGEMAIL = "billing-pls@cru.org";
export const DEFAULTURL = "https://billing.myletterservice.org";
export const BILLINGADMIN = "amy.scholz@cru.org";